module.exports = __webpack_public_path__ + "static/media/neutral.037dc967.svg";